// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZrmListingsWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerAccountViewZrmListingsWebApiHandler_applications,
  RentalManagerAccountViewZrmListingsWebApiHandler_applications_Path,
  RentalManagerAccountViewZrmListingsWebApiHandler_leads,
  RentalManagerAccountViewZrmListingsWebApiHandler_leads_Path,
  RentalManagerAccountViewZrmListingsWebApiHandler_list,
  RentalManagerAccountViewZrmListingsWebApiHandler_list_Path,
  RentalManagerAccountViewZrmListingsWebApiHandler_options,
  RentalManagerAccountViewZrmListingsWebApiHandler_options_Path,
  RentalManagerAccountViewZrmListingsWebApiHandler_units,
  RentalManagerAccountViewZrmListingsWebApiHandler_units_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  AccountViewListingOptionsDto,
  AccountViewTableCellDto,
  FilterStatusType,
  ListingAlias,
  ListingPropertyUnitsResponseDto,
  ListingUnitsResponseDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface ApplicationsParams {
  listingAlias: ListingAlias;
}
interface LeadsParams {
  listingAlias: ListingAlias;
}
interface ListParams {
  limit?: number;
  searchText?: string;
  startKeyExclusive?: ListingAlias;
  status?: FilterStatusType;
}
interface OptionsParams {
  listingAlias: ListingAlias;
}
interface UnitsParams {
  groupId: string;
  limit?: number;
  startKeyExclusive?: ListingAlias;
  status?: FilterStatusType;
}

export type RentalManagerAccountViewZrmListingsWebApiHandler_applications_Options = UseQueryOptions<
  AccountViewTableCellDto,
  unknown,
  AccountViewTableCellDto,
  readonly [string, ApplicationsParams]
>;

const RentalManagerAccountViewZrmListingsWebApiHandler_applications_GetKey = (getParams: ApplicationsParams) =>
  [RentalManagerAccountViewZrmListingsWebApiHandler_applications_Path, getParams] as const;

export const RentalManagerAccountViewZrmListingsWebApiHandler_applications_queryOptions = (
  getParams: ApplicationsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmListingsWebApiHandler_applications_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmListingsWebApiHandler_applications(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user account view unit applications count
 */
export const useRentalManagerAccountViewZrmListingsWebApiHandler_applications = (
  getParams: ApplicationsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmListingsWebApiHandler_applications_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmListingsWebApiHandler_applications_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmListingsWebApiHandler_applications.getKey =
  RentalManagerAccountViewZrmListingsWebApiHandler_applications_GetKey;

export type RentalManagerAccountViewZrmListingsWebApiHandler_leads_Options = UseQueryOptions<
  AccountViewTableCellDto,
  unknown,
  AccountViewTableCellDto,
  readonly [string, LeadsParams]
>;

const RentalManagerAccountViewZrmListingsWebApiHandler_leads_GetKey = (getParams: LeadsParams) =>
  [RentalManagerAccountViewZrmListingsWebApiHandler_leads_Path, getParams] as const;

export const RentalManagerAccountViewZrmListingsWebApiHandler_leads_queryOptions = (
  getParams: LeadsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmListingsWebApiHandler_leads_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmListingsWebApiHandler_leads(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user account view unit leads count
 */
export const useRentalManagerAccountViewZrmListingsWebApiHandler_leads = (
  getParams: LeadsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmListingsWebApiHandler_leads_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmListingsWebApiHandler_leads_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmListingsWebApiHandler_leads.getKey =
  RentalManagerAccountViewZrmListingsWebApiHandler_leads_GetKey;

export type RentalManagerAccountViewZrmListingsWebApiHandler_list_Options = UseQueryOptions<
  ListingUnitsResponseDto,
  unknown,
  ListingUnitsResponseDto,
  readonly [string, ListParams]
>;

const RentalManagerAccountViewZrmListingsWebApiHandler_list_GetKey = (getParams: ListParams) =>
  [RentalManagerAccountViewZrmListingsWebApiHandler_list_Path, getParams] as const;

export const RentalManagerAccountViewZrmListingsWebApiHandler_list_queryOptions = (
  getParams: ListParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmListingsWebApiHandler_list_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmListingsWebApiHandler_list(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user account view flat unit list
 */
export const useRentalManagerAccountViewZrmListingsWebApiHandler_list = (
  getParams: ListParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmListingsWebApiHandler_list_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmListingsWebApiHandler_list_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmListingsWebApiHandler_list.getKey =
  RentalManagerAccountViewZrmListingsWebApiHandler_list_GetKey;

export type RentalManagerAccountViewZrmListingsWebApiHandler_options_Options = UseQueryOptions<
  AccountViewListingOptionsDto,
  unknown,
  AccountViewListingOptionsDto,
  readonly [string, OptionsParams]
>;

const RentalManagerAccountViewZrmListingsWebApiHandler_options_GetKey = (getParams: OptionsParams) =>
  [RentalManagerAccountViewZrmListingsWebApiHandler_options_Path, getParams] as const;

export const RentalManagerAccountViewZrmListingsWebApiHandler_options_queryOptions = (
  getParams: OptionsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmListingsWebApiHandler_options_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmListingsWebApiHandler_options(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user account view flat unit row options
 */
export const useRentalManagerAccountViewZrmListingsWebApiHandler_options = (
  getParams: OptionsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmListingsWebApiHandler_options_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmListingsWebApiHandler_options_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmListingsWebApiHandler_options.getKey =
  RentalManagerAccountViewZrmListingsWebApiHandler_options_GetKey;

export type RentalManagerAccountViewZrmListingsWebApiHandler_units_Options = UseQueryOptions<
  ListingPropertyUnitsResponseDto,
  unknown,
  ListingPropertyUnitsResponseDto,
  readonly [string, UnitsParams]
>;

const RentalManagerAccountViewZrmListingsWebApiHandler_units_GetKey = (getParams: UnitsParams) =>
  [RentalManagerAccountViewZrmListingsWebApiHandler_units_Path, getParams] as const;

export const RentalManagerAccountViewZrmListingsWebApiHandler_units_queryOptions = (
  getParams: UnitsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZrmListingsWebApiHandler_units_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZrmListingsWebApiHandler_units(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get zrm user account view unit list for a property
 */
export const useRentalManagerAccountViewZrmListingsWebApiHandler_units = (
  getParams: UnitsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZrmListingsWebApiHandler_units_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZrmListingsWebApiHandler_units_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZrmListingsWebApiHandler_units.getKey =
  RentalManagerAccountViewZrmListingsWebApiHandler_units_GetKey;
